import cogoToast from "cogo-toast";
import { createSlice } from "@reduxjs/toolkit";
import { t } from "i18next";

const compareSlice = createSlice({
  name: "compare",
  initialState: {
    compareItems: [],
  },
  reducers: {
    addToCompare(state, action) {
      state.compareItems.push(action.payload);
      cogoToast.success(t("item_added_to_compare"), {
        heading: t("compare"),
        position: "bottom-center",
      });
    },
    deleteFromCompare(state, action) {
      state.compareItems = state.compareItems.filter(
        (item) => item.id !== action.payload
      );
      cogoToast.error(t("item_removed_from_compare"), {
        heading: t("compare"),
        position: "bottom-center",
      });
    },
  },
});

export const { addToCompare, deleteFromCompare } = compareSlice.actions;
export default compareSlice.reducer;
